import React from 'react';
import c from '../Dilution.module.css';

export const Socket = ({ children }) => {
  return <div className={c.rtSocket}>{children}</div>;
};
